import {
    AnalyticsApi,
    AnalyticsEvent,
    DiscoveryApi,
    IdentityApi,
} from '@backstage/core-plugin-api';
import getUuid from 'uuid-by-string';

export class StatisticClient implements AnalyticsApi {
    discoveryApi: DiscoveryApi;
    identityApi: IdentityApi;
    topic: string | undefined;

    constructor(identityApi: IdentityApi, discoveryApi: DiscoveryApi) {
        this.discoveryApi = discoveryApi;
        this.identityApi = identityApi;
    }

    static fromConfig(identityApi: IdentityApi, discoveryApi: DiscoveryApi) {
        return new StatisticClient(identityApi, discoveryApi);
    }

    async captureEvent(event: AnalyticsEvent) {
        let user = '';
        await this.identityApi.getBackstageIdentity().then(identity => {
            user = getUuid(identity.userEntityRef, 3);
        });
        event.subject = event.subject.replaceAll(
            '\\/catalog\\/default\\/user\\/.*',
            '/catalog/default/user/***',
        );

        if (/\/catalog\/default\/user\/.*/.exec(event.subject)) {
            event.subject = '/catalog/default/user/***';
            event.attributes!.name = '***';
        }
        if (/\/catalog\/default\/user\/.*/.exec(String(event.attributes?.to))) {
            event.attributes!.to = '/catalog/default/user/***';
            event.subject = '***';
        }
        const enrichedEvent = {
            user: user,
            event: event,
        };
        await fetch(
            `${await this.discoveryApi.getBaseUrl('statistic')}/event`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${(await this.identityApi.getCredentials()).token}`,
                },
                body: JSON.stringify(enrichedEvent),
            },
        );
    }
}
